import { NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { TextEditorComponent } from './components/text-editor/text-editor.component';
import { NgxEditorModule } from "ngx-editor";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@NgModule({
  declarations: [
    TextEditorComponent,
  ],
  imports: [
    MatExpansionModule,
    MatTabsModule,
    MatNativeDateModule,
    MatDialogModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatSelectModule,
    NgxEditorModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    MatExpansionModule,
    MatTabsModule,
    MatNativeDateModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    TextEditorComponent,
  ],
})
export class MaterialModule { }
